export const requiredFields = [
	{ key: 'atsIntegrationKeyorUrl', message: 'Please enter API key' },
	{ key: 'atsIntegrationName', message: 'Please select ATS Name' },
	{ key: 'bonusReferral', message: 'Please enter referral amount' },
];
